import { useEffect, useState, useMemo } from 'react'
import ModalEditGoodsList from './editazmanot/goodslistEdit'
import { useDispatch, useSelector } from 'react-redux'
import ProductGroupSelector from '../Components/ProductGroupSelector'
import { convertToDate } from '../../../../../modules/convertDateString'
import styled from 'styled-components'
import { format } from 'date-fns'
import BasketIcon from '../../../../../generic/icons/IconLib/BasketIcon'
import CloseIcon from '../../../../../generic/icons/IconLib/XIcon'
import ErrorIcon from '../../../../../generic/icons/IconLib/AlertCircleIcon'
import ChecklistIcon from '../../../../../generic/icons/IconLib/ChecklistIcon'
import EditIcon from '../../../../../generic/icons/IconLib/PencilIcon'
import { LOAD, LOAD_END } from '../../../../../../store/actions/actionsTypes'
import DetailesModal from './editazmanot/DetailesModal'
import selectBrodMigdal from '../../../../../generic/utils/selectBrodMigdal'
import { useNavigate, useParams } from 'react-router-dom'
import { Orders } from '../../../../../modules/API/Orders/orders'
import { LINKS } from '../../../../../Routs/config'
import { addIDForTheList } from '../../../../../generic/utils/addUIDForTheList'
import useDataFetcher from '../../knisot/hooks/useFetchData'
import { Defaults } from '../../../../../modules/API/Defaults/defaults'
import Basket from '../../../../../generic/basket/Basket'
import useBasket from './hooks/useBasket'
import ColumModal from '../../../../../generic/Layouts/ColumModal'
import RemarkOrderModal from '../Components/RemarkOrderModal'
import useRemarkModal from '../../../../../generic/hooks/useRemarkModal'
import { handleNotifications } from '../../../../../generic/utils/handleNotifications'
import OrdersPageLayout from '../Components/OrdersPageLayout'
import ClientSelector from '../../../../../generic/ui/ClientSelector/ClientSelector'
import DateField from '../Components/DateField'
import OrderActionDock from '../Components/OrderActionDock'
import OrderHeaderBlock from '../Components/OrderHeaderBlock'
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton'
import OrdersToolbar from '../Components/OrdersToolbar'
import SearchableSelect from '../../../../../generic/ui/SearchableSelect/SearchableSelect'
export default function ModalEditAzmana() {
    const user = useSelector(token => token.mainReducer.user);
    const defaults = useSelector(e => e.defaults?.defaults);
    const clienthash = useSelector(e => e.defaults?.clientList?.hashTable);
    const navigate = useNavigate();
    const isOffice = user.rights.includes("OFFICE");
    // NEW
    const { id } = useParams()
    const packegeList = useSelector(packages => packages?.defaults?.packageList);

    // TODO: realise for what is this
    const [productEditList, setProdactEditList] = useState([])
    const [fileterGoodsDefault, setFilterGoodsDefault] = useState([])
    const [editGoodsDefault, setEditGoodsDefault] = useState([])
    const [editGoods, setEditGoods] = useState([])
    const [elementAzmanot, setElementAzmanot] = useState({})
    const getMlai = selectBrodMigdal(defaults, 546, 'Logical_Value');
    const getMhir = selectBrodMigdal(defaults, 547, 'Logical_Value');
    const {
        data: productGroupList
    } = useDataFetcher(
        Defaults.getProductGroup, "data"
    )
    // ! NEW


    const getTimeBrod = selectBrodMigdal(defaults, 342, 'Time_Value');
    const isEditArizot = selectBrodMigdal(defaults, 584, 'Logical_Value');
    // const neededStatusPritim = selectBrodMigdal(defaults, 549, 'Logical_Value');
    const neededStatusPritim = clienthash[elementAzmanot.CustomerID]?.NeedGrowthGroup !== 0;
    const [imputGoods, setInputGoods] = useState('');
    const [productNonOrder, setProductNonOrder] = useState([])
    const [statusFilter, setStatisFilter] = useState(true)
    const [filteredExist, setFilteredExist] = useState([])
    const currentTime = format(new Date(), "HHmm00");
    const [filterGoodsValue, setFilterGoodsValue] = useState(null)

    const [filterToggleStatus, setFilterToggleStatus] = useState(false)
    const dispatch = useDispatch();

    // Memoized cleaned products for API calls (filters out frontend-only properties)
    const cleanedProducts = useMemo(() => {
        return productNonOrder.map(product => {
            const { packType, isExistingOrder, isModified, ...cleanProduct } = product;
            return cleanProduct;
        });
    }, [productNonOrder]);

    const { Status, Remarks, OrderID, Delivery_Date, CustomerID } = elementAzmanot

    // Use the custom remark modal hook
    const {
        isOpen: isRemarkModalOpen,
        remark: remarkText,
        handleToggle: handleOpenRemarkModal,
        modalProps: modalRemarkProps
    } = useRemarkModal({ defaultRemark: Remarks });

    const showEditAzmana = () => {
        //clear all arrays who collected preveose data, before open new one, that needs for keep uniq empty fields
        navigate(LINKS.orders.clientOrders.mainUrl)
    }

    // NEW
    const insertRecomenInArr = (arr, recArr) => {
        for (let i in arr) {
            for (let j in recArr) {
                if (arr[i].ProductID === recArr[j].ProductID && arr[i].VarietyID === recArr[j].VarietyID) {
                    arr[i].RecommendQty = recArr[j]
                }
            }
        }
        return arr
    }

    const testAdd = () => { // sort azmanot by packs value
        let newArrAdded = []
        editGoods.forEach(element => {
            for (let i = 0; i < productEditList.length; i++) {
                if (productEditList[i].desc === element.desc) {
                    element.packs = productEditList[i].packs
                }
                if (element.packs === undefined) {
                    element.packs = '0'
                }
            }
            newArrAdded.push(element)
        });

        setEditGoods(newArrAdded)
    }

    useEffect(() => {
        testAdd()
    }, [elementAzmanot])

    useEffect(() => {
        if (!id) return
        const getOrder = async (id) => {
            dispatch({ type: LOAD });
            try {
                let res = await Orders.getOrder(id);
                const title = res.orderTitle
                setElementAzmanot(res.orderTitle)
                const formatedOrder = addIDForTheList(title.Status === 0 ? res.recommendations.concat(res.orderDetails) : res.orderDetails)

                const dataWithRecs = insertRecomenInArr(formatedOrder, res.recomWithQtyBySales).sort((a, b) => (b.OrderPacks || 0) - (a.OrderPacks || 0))

                const filtered = (dataWithRecs).filter(item => {
                    return item.GroupArray.includes(title.GroupID)
                })
                const isDividedByKwucot = clienthash[res.orderTitle.CustomerID]?.NeedGrowthGroup !== 0
                if (isDividedByKwucot) {
                    setEditGoodsDefault(filtered)
                    setEditGoods(filtered)

                } else {
                    setEditGoodsDefault(dataWithRecs)
                    setEditGoods(dataWithRecs)

                }

            } catch (err) {


            } finally {
                dispatch({ type: LOAD_END });

            }
        }
        // TODO: add groupID
        getOrder(id)

    }, [id])

    // ! NEW

   

    // <--     collect and fetch data for edit azmana

    const editAzmana = async () => {
        dispatch({ type: LOAD })

        const reqData = {
            "Remark": remarkText.trim(),
            "Products": cleanedProducts,
            "Status": Status
        }
        try {
            let res = await Orders.editOrder(OrderID, reqData);
            handleNotifications(res.message, {type: 'success'})
          
            navigate(LINKS.orders.clientOrders.mainUrl);
        } catch (err) {
            handleNotifications(err.response.data.message, {type: 'error'})
            
        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    // filter by name
    const filterGoods = async (imputGoods) => {
        if (statusFilter) {
            const filtered = editGoodsDefault.filter(goods => {
                return `${goods.ProductDesc.trim()} ${goods.VarietyDesc.trim()} ${goods.SizeID.trim()}`.toLowerCase().includes(imputGoods.toLowerCase())
            })
            setInputGoods(imputGoods);
            setEditGoods(filtered);
        }
        if (!statusFilter) {
            const filtered = filteredExist.filter(goods => {
                return `${goods.ProductDesc.trim()} ${goods.VarietyDesc.trim()} ${goods.SizeID.trim()}`.toLowerCase().includes(imputGoods.toLowerCase())
            })
            setInputGoods(imputGoods);
            setEditGoods(filtered);
        }
    }

    const filterExist = () => {
        const filtered = editGoods.filter(goods => {
            if (goods.Packs > 0 || goods.OrderPacks) {
                return goods.Packs > 0 || goods.OrderPacks > 0
            }
        })
        if (filtered.length > 0) {
            setEditGoods(filtered);
            setStatisFilter(false)
            setFilteredExist(filtered)
        }
    }
    const getGoodPrice = async (prodID, varietyID, sizeID, packID, id, item) => {
        try {
            let res = await Orders.getGoodPrice(Delivery_Date, CustomerID, prodID, varietyID, sizeID, packID);
            let tempDef = [...editGoodsDefault]
            let temp = [...editGoods]
            let editedDef = tempDef.map((item) => {
                if (item.id === id) {
                    item.Price = res[0].CustPrice
                    item.SalePrice = res[0].CustPrice
                    item.MinPrice = res[0].MinimumPrice
                    item.OriginalPrice = res[0].CustPrice
                    item.isPriced = true
                }
                return item
            })
            setEditGoodsDefault(editedDef)

            let edited = temp.map((item) => {
                if (item.id === id) {
                    item.Price = res[0].CustPrice
                    item.SalePrice = res[0].CustPrice
                    item.MinPrice = res[0].MinimumPrice
                    item.OriginalPrice = res[0].CustPrice
                    item.isPriced = true
                }
                return item
            })
            setEditGoods(edited)
        } catch (err) { }
    }
    // merge keys of Fetched data and setproduct data, merge orderPacks with packs keytypes. Collect new sorted data
    const filterExistDef = async () => {
        let newArr = [...editGoodsDefault]
        for (let i = 0; i < editGoodsDefault.length; i++) {
            for (let j = 0; j < productNonOrder.length; j++) {
                if (productNonOrder[j].id === editGoodsDefault[i].id) {
                    newArr[i].Packs = productNonOrder[j].Packs
                    newArr[i].OrderPacks = productNonOrder[j].Packs
                    newArr[i].Price = productNonOrder[j].Price
                    newArr[i].Mlai = productNonOrder[j].Mlai
                    newArr[i].OriginalPrice = productNonOrder[j].OriginalPrice
                }
            }
        }
        setEditGoodsDefault(newArr)
    }

    useEffect(() => { filterExistDef() }, [productNonOrder])

    const filterClose = async () => {
        const sorted = editGoodsDefault.sort(function (a, b) {
            return a.Packs - b.Packs
        })
        const sortedFiltered = fileterGoodsDefault.sort(function (a, b) {
            return a.Packs - b.Packs
        })
        const sortedReverse = sorted.reverse()
        const sortedFilteredReverse = sortedFiltered.reverse()
        // check filter status and set exist values
        if (!statusFilter && !filterToggleStatus) {
            setEditGoods(sortedReverse)
            setStatisFilter(true)
        }
        if (!statusFilter && filterToggleStatus) {
            setEditGoods(sortedFilteredReverse)
            setStatisFilter(true)
        }
    }

    const filterProblemGoods = () => {
        const filtered = editGoodsDefault.filter(item =>
            item.OrderPacks !== item.SupplyQty || item.ChangeReason !== 0
        )
        setStatisFilter(false);
        setEditGoods(filtered);
    }

    const countOrder = useMemo(() => {
        if (editGoods.length === 0 || !editGoods) return 0
        const merged = editGoods.map((item) => {
            const found = productNonOrder.find((prod) => prod.id === item.id)
            if (found) {
                return {
                    ...item,
                    ...found
                }
            }
            return item
        })

        return merged.reduce((acc, item) => {
            return acc + ((item?.OrderPacks || 0) || (item?.Packs || 0))
        }, 0)
    }, [editGoods, productNonOrder])

    let filterToggle = neededStatusPritim
        ? <SearchableSelect
            items={[]}
            value={{ GroupID: elementAzmanot?.GroupID ?? 0, GroupDesc: elementAzmanot?.GroupDesc?.trim() ?? '' }}
            onSelect={() => {}}
            getKey={(g) => g.GroupID}
            getLabel={(g) => g.GroupDesc}
            readOnly
            placeholder=''
        />
        : <ProductGroupSelector
            fileterGoods={productGroupList?.productsGroups || []}
            setFilterGoodsValue={setFilterGoodsValue}
            goodsListDefault={editGoodsDefault}
            setGoodsList={setEditGoods}
            setFilterToggleStatus={setFilterToggleStatus}
            setFilterGoodsDefault={setFilterGoodsDefault}
            setFilteredExist={setFilteredExist}
        />
    let trimmed = elementAzmanot?.Customer_Name ? elementAzmanot?.Customer_Name.trim() : ''
    let convertedDate = elementAzmanot?.Delivery_Date ? convertToDate(elementAzmanot.Delivery_Date) : 'no-data'

    let disabelSave = !isOffice && (
        Status !== 0
            || (elementAzmanot?.To_PickupTime !== '000000' && +elementAzmanot?.To_PickupTime < +currentTime)
            || (elementAzmanot?.To_PickupTime === '000000' && +getTimeBrod < +currentTime) ? true : false
    )

    let checkButtoFilter = statusFilter ?
        disabelSave ?
            <KbdChipButton aria-label='filter problems' count={countOrder} onClick={() => { filterProblemGoods() }}>
                <ErrorIcon />
            </KbdChipButton>
            :
            <KbdChipButton aria-label='filter existing' count={countOrder} onClick={() => { filterExist() }}>
                <ChecklistIcon />
            </KbdChipButton>
        : <KbdChipButton aria-label='close filter' count={countOrder} onClick={() => { filterClose() }}>
            <CloseIcon />
        </KbdChipButton>;

    const [dataForDetailes, setDataForDetailes] = useState(null);
    const [isOpenDetailes, setIsOpenDetailes] = useState(false);

    const showDetailes = (disabelSave, ChangeReason) => {
        if (disabelSave && ChangeReason === 5) {
            setIsOpenDetailes(!isOpenDetailes)
        }
    }

    // Use the custom basket hook
    const {
        isBasketOpen,
        basketProducts,
        basketQuantities,
        handleToggleBasket,
        handleCloseBasket
    } = useBasket({
        mode: 'edit',
        packegeList,
        editGoods,
        productNonOrder,
        editGoodsDefault
    });

    const handleControllBasket = () => {
        handleToggleBasket();
    }

    return (
        <>
            <DetailesModal
                open={isOpenDetailes}
                close={() => { setIsOpenDetailes(false) }}
                data={dataForDetailes?.data}
                title={dataForDetailes?.title}
            />
            {isRemarkModalOpen &&
                <ColumModal
                    open={isRemarkModalOpen}
                    controlFunc={handleOpenRemarkModal}
                    title={'הערות'}
                    Children={RemarkOrderModal}
                    childrenProps={modalRemarkProps}
                />
            }
            <Basket
                Remark={remarkText}
                products={basketProducts}
                quantities={basketQuantities}
                isOpen={isBasketOpen}
                onClose={handleCloseBasket}
                onToggle={handleToggleBasket}
            />
            <OrdersPageLayout title={`עריכת הזמנה${OrderID ? ` · ${OrderID}` : ''}`}>
                <ModalEditGoodsList
                    productNonOrder={productNonOrder}
                    setProductNonOrder={setProductNonOrder}
                    setEditGoods={setEditGoods}
                    editGoods={editGoods}
                    productEditList={productEditList}
                    packegeList={packegeList}
                    setProdactEditList={setProdactEditList}
                    disabelSave={disabelSave}
                    getMlai={getMlai}
                    getMhir={getMhir}
                    showDetailes={showDetailes}
                    setDataForDetailes={setDataForDetailes}
                    isEditArizot={isEditArizot}
                    date={elementAzmanot.Delivery_Date}
                    getGoodPrice={getGoodPrice}
                    scrollHeader={
                        <OrderHeaderBlock
                            client={
                                <ClientSelector
                                    clients={[]}
                                    readOnly
                                    value={CustomerID ? { CustomerID, Customer_Name: trimmed } : null}
                                    onSelect={() => {}}
                                />
                            }
                            date={
                                <DateField readOnly value={convertedDate || ''} />
                            }
                        />
                    }
                    stickyHeader={
                        <OrdersToolbar
                            groupSelector={filterToggle}
                            actions={
                                <>
                                    <KbdChipButton aria-label='remark' onClick={() => handleOpenRemarkModal()}>
                                        <EditIcon />
                                    </KbdChipButton>
                                    <KbdChipButton aria-label='basket' onClick={() => handleControllBasket()}>
                                        <BasketIcon />
                                    </KbdChipButton>
                                </>
                            }
                            filterButton={checkButtoFilter}
                            searchValue={imputGoods}
                            onSearchChange={(v) => filterGoods(v)}
                        />
                    }
                />
            </OrdersPageLayout>
            <OrderActionDock
                onClose={showEditAzmana}
                onSave={editAzmana}
                saveLabel={'שמור שינויים'}
                saveDisabled={disabelSave}
            />
        </>
    );
}

